(function ($) {

    /**
     *
     * @returns {*}
     */
    $.fn.productionBatch = function (box, data = null) {
        const GLIDE_SETTINGS = {
            perView: 1,
            startAt: 0,
            rewind: false,
            type: 'slider',
            drag: false,
            swipeThreshold: 0,
            dragDistance: false,
            keyboard: false,
            touchAngle: 0
        };

        /**
         *
         */
        return this.each(function () {
            let batch = this;
            batch.box = box;

            batch.accordion = null;
            batch.batchId = null;
            batch.batchName = null;
            batch.glideId = null;
            batch.glider = null;
            batch.showNumber = null;
            batch.spools = new Set();
            batch.spoolsContainer = null;

            /**
             *
             */
            batch.init = (data) => {
                batch.initElements();
                batch.initButtons();
                batch.initGlide();
                batch.setData(data);
                batch.postInit();
            }

            /**
             *
             */
            batch.initElements = () => {
                batch.spoolsContainer = $('ul.production-spools', $(batch));
                batch.glide = $('.glide', $(batch));
                batch.glideId = 'glide_' + crypto.randomUUID();
                batch.glide.prop('id', batch.glideId);

                let maxWidth = (batch.glide.parent().parent().innerWidth());
                batch.glide.css('max-width', `${maxWidth}px`);
                batch.glide.css('min-width', '768px');
                batch.glide.css('margin', 0);
                batch.showNumber = $('span.batch-no', $(batch));
            }

            /**
             *
             */
            batch.initButtons = () => {
                window.blur();
            }

            /**
             *
             */
            batch.postInit = () => {
                batch.accordion = $(this).productionAccordion($('> .title.folder-open', $(batch)), $('.production-batch', $(batch)));
                batch.setNumber();

                // Loop through the batch spools and disable next button on all but the last spool.
                let spools = batch.spools;
                let lastSpool = null;
                spools.forEach((spool) => {
                    if (lastSpool !== null) {
                        lastSpool.btnSpoolPrintNext.prop('disabled', true);
                    }
                    lastSpool = spool;
                });
            }

            /**
             *
             */
            batch.initGlide = () => {
                // Remove the old glide if set.
                if (batch.glider !== null) {
                    batch.glider.destroy();
                }
                batch.glider = new Glide('#' + batch.glideId, GLIDE_SETTINGS);
                batch.glider.on(['run', 'mount.after'], function () {
                    let left = $('button[data-glide-dir="<"]', batch.glide);
                    let right = $('button[data-glide-dir=">"]', batch.glide);
                    if (batch.glider.index === 0) {
                        left.css('opacity', 0.05);
                        left.css('cursor', 'default');
                    } else {
                        left.css('opacity', 1);
                        left.css('cursor', 'pointer');
                    }
                    if ((batch.glider.index + 1) >= $('ul li', batch).length) {
                        right.css('opacity', 0.05);
                        right.css('cursor', 'default');
                    } else {
                        right.css('opacity', 1);
                        right.css('cursor', 'pointer');
                    }
                });
                batch.glider.mount();

                $('[data-glide-dir="<"]', batch.glide).off('click keydown').on('click keydown', function () {
                    batch.glider.go('<');
                });
                $('[data-glide-dir=">"]', batch.glide).off('click keydown').on('click keydown', function () {
                    batch.glider.go('>');
                });
            }

            /**
             *
             */
            batch.newSpool = (data = null, next = false) => {
                let template = $('#spool-template').html();
                let newElement = $(template).appendTo(batch.spoolsContainer);
                let spool = newElement.productionSpool(this, data);
                batch.spools.add(spool);
                if (next) {
                    batch.glider.mount();
                    batch.nextSlide();
                    setTimeout(() => {
                        $('[name="gross_weight"]', newElement).focus();
                    }, 200);
                }
            }

            /**
             *
             */
            batch.nextSlide = () => {
                batch.glider.go('>');
            }

            /**
             *
             * @returns {{box_id: *, batch_id: *, product_id: *, sales_order_id: *, pallet_id: *}}
             */
            batch.getData = () => {
                return {
                    batch_id: batch.box.pallet.production.getBatchId(),
                    box_id: batch.getBoxId(),
                    pallet_id: batch.getPalletId(),
                    product_id: batch.getProductId(),
                    sales_order_line_id: batch.getSalesOrderLineId(),
                };
            }

            /**
             *
             * @returns {null|number|*}
             */
            batch.getBatchId = () => {
                return batch.box.pallet.production.getBatchId();
            }

            /**
             *
             * @returns {null|*}
             */
            batch.getBatchName = () => {
                return batch.box.pallet.production.getBatchName();
            }

            /**
             *
             * @returns {*}
             */
            batch.getBoxId = () => {
                return batch.box.getBoxId();
            }

            /**
             *
             * @returns {number}
             */
            batch.getLastTubeInt = () => {
                let tube_int = 0;
                $('.tube_int', batch).each(function () {
                    let value = parseInt($(this).text());
                    if (value > tube_int) {
                        tube_int = value;
                    }
                });
                return tube_int;
            }

            /**
             *
             * @returns {*}
             */
            batch.getPalletId = () => {
                return batch.box.getPalletId();
            }

            /**
             *
             * @returns {*}
             */
            batch.getProductId = () => {
                return batch.box.getProductId();
            }

            /**
             *
             * @returns {*}
             */
            batch.getSalesOrderId = () => {
                return batch.box.getSalesOrderId();
            }

            /**
             *
             * @returns {*}
             */
            batch.getSalesOrderLineId = () => {
                return batch.box.getSalesOrderLineId();
            }

            /**
             *
             * @param data
             */
            batch.setData = (data) => {
                if (data !== null) {
                    batch.setBatchId(data.id);
                    $.each(data.spools, function (foo, spool) {
                        batch.newSpool(spool);
                    })
                } else {
                    batch.newSpool();
                }
                batch.glider.mount();

                // Glide to last item
                setTimeout(() => {
                    batch.glider.go('=' + ($('ul li', batch).length - 1));
                }, 100);

            }

            /**
             *
             * @param batch_id
             */
            batch.setBatchId = (batch_id) => {
                batch.batchId = parseInt(batch_id);
            }

            /**
             *
             */
            batch.setNumber = () => {
                batch.showNumber.text(batch.getBatchName());
            }

            /**
             *
             * @param pallet_id
             */
            batch.setPalletId = (pallet_id) => {
                batch.box.setPalletId(pallet_id);
            }

            /**
             *
             * @param box_id
             */
            batch.setBoxId = (box_id) => {
                batch.box.setBoxId(box_id);
            }

            /**
             *
             * @param spoolToRemove
             */
            batch.deleteSpool = (spoolToRemove) => {
                batch.spools.forEach((spool) => {
                    if (spool === spoolToRemove) {
                        spool.remove();
                        batch.spools.delete(spool);
                    }
                })
                batch.glider.mount();
            }

            batch.init(data);

            return batch;
        })[0];
    }

}(jQuery));
